// extracted by mini-css-extract-plugin
module.exports = {"header__name":"header__name-SRAHl","change":"change-29urQ","money":"money-1YNuM","charge":"charge-3ZAMI","total":"total-333dv","total__money":"total__money-345LO"};